module.exports = __webpack_public_path__ + "static/media/more-icon.71a3f871.svg";